import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import fa_IR from 'antd/locale/fa_IR';
import './index.css';
import './assets/fonts/fonts.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'antd/dist/reset.css'; // یا antd/dist/antd.css

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <ConfigProvider
    locale={fa_IR}
    theme={{
      token: {
        fontFamily: '"Vazir", sans-serif',
      },
    }}
  >
    <App />
  </ConfigProvider>
);

reportWebVitals();
